import React from 'react'

import { Container } from './styles'

export const Spinner = () => {
  return <Container />
}
